import env from '../config/env';
import axiosInstance from './';

export default class {
  constructor() {
    this.instance = axiosInstance(env.REACT_APP_TAGS_ENDPOINT);
  }

  get = () => this.instance({ url: '/tags', method: 'GET' });
}



// WEBPACK FOOTER //
// ./src/services/Tags.js